<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <div>
              <v-img class="img" src="/static/logo.png"></v-img>
            </div>
            <v-card :style="{ maxWidth: '400px' }" class="mx-auto mt-16 x-5">

              <v-toolbar dark color="primary">
                <v-toolbar-title class="title-bold">Acesso</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="mt-10">
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-text-field
                    autofocus
                    type="email"
                    v-model="email"
                    label="E-mail"
                    :rules="emailRules"
                    required
                    prepend-icon="mdi-account-circle"
                  />
                  <v-text-field
                    :type="showPassword ? 'text' : 'password'"
                    :rules="passwordRules"
                    v-model="password"
                    label="Senha"
                    v-on:keyup.enter="validate"
                    prepend-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-row
                  align="center"
                  justify="end"
                >
                  <v-btn
                    style="margin-bottom: 10px;"
                    class="mr-5"
                    :disabled="!email || !password"
                    color="primary"
                    @click="validate"
                  >
                    Entrar
                  </v-btn>
                  <v-btn
                    :disabled="!email"
                    style="margin-bottom: 10px;"
                    class="mr-5"
                    @click="resetPassword"
                  >
                    Esqueci minha senha
                  </v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <modal-privacy></modal-privacy>
    <first-access-modal @alter-password="alterPassword" :newPasswordProp.sync="newPassword" :showModalAccessProp.sync="showModalAccess"/>
  </v-app>
</template>

<script>
import message from '@/utils/message'
import ModalPrivacy from '@/components/politics/ModalPrivacy'
import api from '@/services/api'
import FirstAccessModal from '@/components/modals/FirstAccessModal'

export default {
  components: {
    ModalPrivacy,
    FirstAccessModal
  },
  data: () => ({
    valid: true,
    showPassword: false,
    email: '',
    password: '',
    emailRules: [
      v => !!v || 'E-mail é obrigatório'
    ],
    passwordRules: [
      v => !!v || 'Senha é obrigatório'
    ],
    userId: null,
    showModalAccess: false,
    newPassword: null
  }),

  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.login()
      }
    },

    async alterPassword () {
      this.showModalAccess = false
      try {
        api.put('/users/first-access', { password: this.newPassword })
        message.success('Senha atualizada')
      } catch (error) {
        message.error('Erro ao atualizar senha')
      } finally {
        this.toHome()
      }
    },

    async resetPassword () {
      try {
        await api.post('/reset-password', { email: this.email })
        message.success('Nova senha enviada para o e-mail informado')
      } catch (error) {
        message.error(error.message)
      }
    },

    async login () {
      try {
        let payload = {
          email: this.email,
          password: this.password
        }

        const { data } = await api.post('/tokens', payload)

        const { token, user } = data
        this.$store.commit('setToken', token)
        this.$store.commit('setUserType', user.role)
        this.$store.commit('setId', user.id)
        this.userId = user.id

        // role de corretor
        if (user.role.id === 2 || user.role.id === 3) {
          this.$store.commit('setRealState', user.realState)
          this.$store.commit('setBroker', { id: user.id, name: user.name })
        }

        if (user.first_access) {
          message.success('Usuário autenticado!')
          this.showModalAccess = true
          return
        }

        this.toHome()
      } catch (error) {
        message.error(error.message)
      }
    },

    async toHome () {
      this.$router.push({ name: 'clients' })
    }
  }
}
</script>

<style scoped>
  .img {
    max-width: 220px;
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue